import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
    en: {
        cancel: "CANCEL",
        change: "SAVE CHANGES",
        delete: "Delete",
        deletePictogram: "Delete interface",
        deletePictogramConfirmation: "Are you sure you want to delete the interface",
        edit: "Edit",
        image: "Image",
        managingPictograms: "Pictogram management",
        nameEn: "Name (EN)",
        nameEnLong: "Name in English",
        namePt: "Name (PT)",
        namePtLong: "Name in Portuguese",
        newPictogram: "Create",
        noExistingPictograms: "There are no existing interfaces",
        removeImage: "Remove image",
        required: "Mandatory",
        upload: "Upload",
    },
    pt: {
        cancel: "CANCELAR",
        change: "GUARDAR ALTERAÇÕES",
        delete: "Apagar",
        deletePictogram: "Apagar interface",
        deletePictogramConfirmation: "Tem a certeza que deseja apagar a interface",
        edit: "Editar",
        image: "Imagem",
        managingPictograms: "Gestão de interfaces",
        nameEn: "Nome (EN)",
        nameEnLong: "Nome em Inglês",
        namePt: "Nome (PT)",
        namePtLong: "Nome em Português",
        newPictogram: "Criar",
        noExistingPictograms: "Não existem interfaces.",
        removeImage: "Remover imagem",
        upload: "Carregar"
    }
});
